module.exports = __webpack_public_path__ + "img/microplastics-process-9-mobile.ea36c485.png";